import AvatarList, {
  AVATAR_DISPLAY_LIMIT,
} from "@domains/common/views/components/AvatarList/AvatarList";
import useModalState from "@logics/hooks/useModalState";
import ProjectMemberViewModel from "@domains/project/viewModel/ProjectMemberViewModel";

import AvatarListBottomSheet from "../../components/AvatarListBottomSheet/AvatarListBottomSheet";

import * as S from "./AvatarListSection.style";

interface AvatarListSectionProps {
  maxMemberCount: number;
  memberList: ProjectMemberViewModel[];
}

const AvatarListSection = ({
  maxMemberCount,
  memberList,
}: AvatarListSectionProps) => {
  const { openModal } = useModalState();

  const handleClickAvatarList = () =>
    openModal({
      CustomComponent: <AvatarListBottomSheet memberList={memberList} />,
    });

  return (
    <S.AvatarSection onClick={handleClickAvatarList}>
      <AvatarList
        spaceBetween
        withBorder
        avatarDisplayLimit={AVATAR_DISPLAY_LIMIT.EVENT}
        avatarList={memberList}
        additionalText={`${memberList?.length}/${maxMemberCount}`}
      />
    </S.AvatarSection>
  );
};

export default AvatarListSection;
